import { render, staticRenderFns } from "./admin_edit.vue?vue&type=template&id=6ba11a37&scoped=true"
import script from "./admin_edit.vue?vue&type=script&lang=ts"
export * from "./admin_edit.vue?vue&type=script&lang=ts"
import style0 from "./admin_edit.vue?vue&type=style&index=0&id=6ba11a37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba11a37",
  null
  
)

export default component.exports